import { gql } from '@apollo/client';

export const QA_ALLOWLIST = gql`
  query QaAllowlist {
    qaAllowlist
  }
`;

export const UPDATE_QA_ALLOWLIST = gql`
  mutation UpdateQaAllowlist($input: UpdateQaAllowlistInput!) {
    updateQaAllowlist(input: $input)
  }
`;

export const EXPORT_USER_STATE = gql`
  mutation ExportUserState($input: ExportUserStateInput!) {
    exportUserState(input: $input) {
      schemaVersion
      exportedAt
      sourceAppId
      sourceUserId
      exportJson
    }
  }
`;

export const IMPORT_USER_STATE = gql`
  mutation ImportUserState($input: ImportUserStateInput!) {
    importUserState(input: $input) {
      destinationUserId
      sourceUserId
      appUserApplied
      missionSetUserRowsApplied
      missionSetUserRowsDeleted
      phaseTwoCounts {
        tableKey
        applied
        deleted
      }
    }
  }
`;
